import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FusionConfig, FusionConfigEnum } from 'src/app/services/fusion-patients/fusion-patients.service';
import { InfosPatient } from 'src/app/utils/interfaces/new/infos-patient.interface';

@Component({
  selector: 'app-fusion-config',
  templateUrl: './fusion-config.fragment.html',
  styleUrls: [
    './fusion-config.fragment.scss',
    '../../../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class FusionConfigFragment implements OnInit {

  public fusionConfigEnum = FusionConfigEnum;
  public formGroup: FormGroup;
  public sourcePatient: InfosPatient;
  public targetPatient: InfosPatient;

  public closeEmitter = new EventEmitter<FusionConfig | undefined>();

  constructor(
    private _formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      prenom: [FusionConfigEnum.SOURCE],
      nom: [FusionConfigEnum.SOURCE],
      dateNaissance: [FusionConfigEnum.SOURCE],
      sexe: [FusionConfigEnum.SOURCE],
    });
  }

  public cancel(): void {
    this.closeEmitter.emit(undefined);
  }

  public validFusionConfig(): void {
    const fusionConfig: FusionConfig = {
      prenom: this.formGroup.get('prenom')?.value,
      nom: this.formGroup.get('nom')?.value,
      dateNaissance: this.formGroup.get('dateNaissance')?.value,
      sexe: this.formGroup.get('sexe')?.value,
    };
    this.closeEmitter.emit(fusionConfig);
  }

}
